/***************************** Email REGEX *****************************/

export const validateEmail = (email: string) => {
  var emailRegex = /^\w.+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
  return emailRegex.test(email);
};

/***************************** Password Validation REGEX *****************************/

export const validatePassword = (password: string) => {
  var passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;
  return passwordRegex.test(password);
};

/***************************** Capitalize First Letter *****************************/

export const capitalizeFirstLetter = (string: string) => {
  return string?.charAt(0)?.toUpperCase() + string?.slice(1);
};

/***************************** Format Date *****************************/
export const formatDate = (dateString: string, format: string) => {
  const date = new Date(dateString);

  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const year = String(date.getFullYear());

  const amPm = date.getHours() >= 12 ? 'PM' : 'AM';
  const twelveHourFormat = date.getHours() % 12 || 12;

  const formattedDate = format
    .replace('MM', month)
    .replace('DD', day)
    .replace('YY', year)
    .replace('HH', hours)
    .replace('mm', minutes)
    .replace('A', amPm)
    .replace('hh', twelveHourFormat.toString().padStart(2, '0'));

  return formattedDate;
};
